module.exports = __webpack_public_path__ + "static/media/DefaultRM.6f122d44.png";